/* RED KICKS size recovery. Does not modify Gecko core files or Shopify inventory. */
(() => {
  'use strict';
  const ROOT = '[data-rk-alt-root]';

  function init(widget) {
    if (widget.dataset.rkAltInit === '1') return;
    const wrapper = widget.closest('.t4s-product-form__variants');
    const isQuickShop = widget.dataset.rkContext === 'quickshop';
    if (!wrapper) return;
    const form = wrapper.querySelector('form[data-type="add-to-cart-form"]');
    const swatch = wrapper.querySelector('.t4s-swatch');
    const sizeIndex = parseInt(widget.dataset.rkOptionIndex, 10);
    const sizeGroup = swatch && swatch.querySelector(`[data-swatch-option][data-id="${sizeIndex}"]`);
    const select = form && form.querySelector('select.t4s-product__select');
    const json = wrapper.querySelector('.pr_variants_json');
    if (!sizeGroup || !form || !json || !select || !Number.isInteger(sizeIndex)) return;
    let variants;
    try { variants = JSON.parse(json.textContent); } catch (_) { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    const templates = new Map();
    widget.querySelectorAll('template[data-rk-size]').forEach(t => templates.set(t.dataset.rkSize, {
      el:t, count:Number(t.dataset.rkCount)||0, url:t.dataset.rkUrl
    }));
    if (!templates.size) return;

    widget.dataset.rkAltInit = '1';
    if(isQuickShop) wrapper.classList.add('rk-alt-is-quickshop');
    sizeGroup.classList.add('rk-alt-size-option');
    const overlay = widget.querySelector('[data-rk-alt-overlay]');
    const inline = widget.querySelector('[data-rk-alt-inline]');
    const inlineGrid = widget.querySelector('[data-rk-alt-inline-grid]');
    const inlineMore = widget.querySelector('[data-rk-alt-inline-more]');
    const modal = widget.querySelector('.rk-alt__dialog');
    const grid = widget.querySelector('[data-rk-alt-grid]');
    const heading = widget.querySelector('[data-rk-alt-title]');
    const subtitle = widget.querySelector('[data-rk-alt-subtitle]');
    const more = widget.querySelector('[data-rk-alt-more]');
    const empty = widget.querySelector('[data-rk-alt-empty]');
    const atc = form.querySelector('[data-atc-form]');
    const atcText = atc && atc.querySelector('.t4s-btn-atc_text');
    const view = document.createElement('a');
    view.className='rk-alt__view';
    view.setAttribute('data-rk-alt-view','');
    const buttons = form.querySelector('.t4s-product-form__buttons');
    if (buttons) buttons.appendChild(view);

    let chosenSize = null;
    let userChosen = false;
    let priorDisabled = false;
    let priorAria = null;
    let priorATCText = null;
    let scheduled = false;
    let lastFocus = null;

    const entries = () => Array.from(sizeGroup.querySelectorAll('[data-swatch-item]'));
    const nativeSelected = () => {
      const selected = sizeGroup.querySelector('[data-swatch-item].is--selected');
      return selected ? selected.dataset.value : null;
    };
    function selectedOtherOptions() {
      const chosen = {};
      swatch.querySelectorAll('[data-swatch-option][data-id]').forEach(group => {
        const i = Number(group.dataset.id);
        if (i === sizeIndex) return;
        const picked = group.querySelector('[data-swatch-item].is--selected');
        if (picked) chosen[i]=picked.dataset.value;
      });
      return chosen;
    }
    function isSizeAvailable(size, others) {
      return variants.some(v => {
        const values=[v.option1,v.option2,v.option3];
        if (String(values[sizeIndex]) !== String(size) || !v.available) return false;
        for (const [k, val] of Object.entries(others)) {
          if (String(values[Number(k)]) !== String(val)) return false;
        }
        return true;
      });
    }
    function itemForSize(size){return entries().find(t=>t.dataset.value===size);}
    function refresh() {
      const others = selectedOtherOptions();
      entries().forEach(item=>{
        const size=item.dataset.value;
        const cfg=templates.get(size);
        const yes=!!cfg && cfg.count>0 && !isSizeAvailable(size,others);
        if(item.classList.contains('rk-alt-enabled')!==yes)item.classList.toggle('rk-alt-enabled',yes);
        if (yes) {
          if(item.dataset.rkAltCount!==String(cfg.count))item.dataset.rkAltCount=String(cfg.count);
          item.setAttribute('role','button');
          item.setAttribute('tabindex','0');
          item.setAttribute('aria-label',`Size ${size} sold out. View ${cfg.count} other styles in this size`);
        } else {
          item.removeAttribute('data-rk-alt-count');
          if(item.getAttribute('role')==='button')item.removeAttribute('role');
          if(item.getAttribute('tabindex')==='0')item.removeAttribute('tabindex');
          if(item.hasAttribute('aria-label') && item.getAttribute('aria-label').includes('sold out'))item.removeAttribute('aria-label');
        }
      });
      if(chosenSize && (!itemForSize(chosenSize)?.classList.contains('rk-alt-enabled'))) clearChoice();
    }
    function scheduleRefresh() {
      if (scheduled)return;
      scheduled=true;
      requestAnimationFrame(()=>{scheduled=false;refresh();});
    }
    function lockATC(){
      if (!atc || userChosen===false) return;
      if (priorATCText===null) priorATCText=atcText ? atcText.textContent : '';
      if (priorAria===null) priorAria=atc.getAttribute('aria-disabled');
      priorDisabled=atc.disabled;
      atc.disabled=true;
      atc.setAttribute('aria-disabled','true');
      if(atcText) atcText.textContent='OUT OF STOCK';
    }
    function unlockATC(){
      if(!atc || !userChosen) return;
      atc.disabled=priorDisabled;
      if(priorAria===null)atc.removeAttribute('aria-disabled');else atc.setAttribute('aria-disabled',priorAria);
      if(atcText && priorATCText!==null)atcText.textContent=priorATCText;
      priorATCText=null;priorAria=null;
    }
    function clearChoice() {
      unlockATC();
      userChosen=false; chosenSize=null;
      wrapper.classList.remove('rk-alt-has-selection');
      entries().forEach(t=>t.classList.remove('rk-alt-user-selected'));
      view.removeAttribute('href');view.textContent='';
      if (inline) inline.hidden = true;
    }
    function activate(size, open, isUserClick) {
      const cfg=templates.get(size);
      if(!cfg||!cfg.count) return;
      if(userChosen)unlockATC();
      userChosen=!!isUserClick;
      chosenSize=size;
      wrapper.classList.add('rk-alt-has-selection');
      entries().forEach(t=>t.classList.toggle('rk-alt-user-selected',t.dataset.value===size));
      view.href=cfg.url;
      view.textContent=`VIEW ${cfg.count} STYLES IN SIZE ${size}  →`;
      if(userChosen) lockATC();
      if(open) openDialog(size);
    }
    function openDialog(size) {
      const cfg=templates.get(size);
      if(!cfg)return;
      if (isQuickShop && inline && inlineGrid) {
        // Same Quick Shop window: no popup over an existing popup.
        inlineGrid.replaceChildren(cfg.el.content.cloneNode(true));
        inline.querySelector('[data-rk-alt-inline-title]').textContent=`Size ${size} is unavailable`;
        inline.querySelector('[data-rk-alt-inline-subtitle]').textContent=`${cfg.count} styles available in size ${size}. Here are 4 to start with.`;
        inline.querySelector('[data-rk-alt-inline-empty]').hidden=inlineGrid.children.length>0;
        inlineMore.href=cfg.url;
        inlineMore.textContent=`VIEW ${cfg.count} STYLES IN SIZE ${size}  →`;
        inline.hidden=false;
        // Quick Shop is already a modal with its own scrolling and focus rules.
        inline.scrollIntoView({block:'nearest', behavior:'smooth'});
        document.dispatchEvent(new CustomEvent('rk:size-alt-open',{detail:{size,productId:widget.dataset.rkProductId,count:cfg.count,context:'quickshop'}}));
        return;
      }
      lastFocus=document.activeElement;
      grid.replaceChildren();
      grid.appendChild(cfg.el.content.cloneNode(true));
      empty.hidden=grid.children.length>0;
      heading.textContent=`Size ${size} is unavailable`;
      subtitle.textContent=`Here are other sneakers available in size ${size}`;
      more.href=cfg.url;
      more.textContent=`VIEW ${cfg.count} STYLES IN SIZE ${size}  →`;
      overlay.hidden=false;
      document.body.classList.add('rk-alt-scroll-locked');
      modal.focus();
      document.dispatchEvent(new CustomEvent('rk:size-alt-open',{detail:{size,productId:widget.dataset.rkProductId,count:cfg.count}}));
    }
    function closeDialog(){
      overlay.hidden=true;
      document.body.classList.remove('rk-alt-scroll-locked');
      if(lastFocus&&lastFocus.isConnected)lastFocus.focus({preventScroll:true});
    }
    widget.querySelectorAll('[data-rk-alt-close]').forEach(el=>el.addEventListener('click',closeDialog));
    document.addEventListener('keydown',e=>{
      if(overlay.hidden)return;
      if(e.key==='Escape'){e.preventDefault();closeDialog();}
      if(e.key==='Tab'){
        const focusables=Array.from(modal.querySelectorAll('button:not([disabled]), a[href]'));
        const first=focusables[0], last=focusables[focusables.length-1];
        if(!first)return;
        if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
      }
    });
    function triggerUnavailable(e) {
      const item=e.target.closest('[data-swatch-item]');
      if(!item || !sizeGroup.contains(item)) return false;
      if(item.classList.contains('rk-alt-enabled')){
        e.preventDefault();e.stopPropagation();if(e.stopImmediatePropagation)e.stopImmediatePropagation();
        activate(item.dataset.value,true,true);
        return true;
      }
      // An available swatch can still be selected through Gecko normally.
      clearChoice();
      setTimeout(scheduleRefresh,90);
      return false;
    }
    sizeGroup.addEventListener('click',triggerUnavailable,true);
    sizeGroup.addEventListener('keydown',e=>{
      if(e.key!=='Enter'&&e.key!==' ')return;
      const item=e.target.closest('[data-swatch-item].rk-alt-enabled');
      if(!item)return;
      e.preventDefault();e.stopPropagation();
      activate(item.dataset.value,true,true);
    },true);
    form.addEventListener('submit',e=>{
      if(userChosen && chosenSize){e.preventDefault();e.stopImmediatePropagation();openDialog(chosenSize);}
    },true);
    // User can change to an available size via other controls or when variant changes.
    select.addEventListener('change',()=>{if(!userChosen) scheduleRefresh();});
    new MutationObserver(scheduleRefresh).observe(swatch,{subtree:true,attributes:true,attributeFilter:['class','data-value'],childList:true});
    refresh();
    const current=nativeSelected();
    if(current && itemForSize(current)?.classList.contains('rk-alt-enabled'))activate(current,false,false);
  }
  function boot(){document.querySelectorAll(ROOT+':not([data-rk-alt-init="1"])').forEach(init);}
  // Gecko Quick Shop injects its section HTML via AJAX. An inline <script> in
  // fetched HTML is not reliable, so watch for newly mounted product forms.
  let bootPending=false;
  function queueBoot(){
    if(bootPending)return;
    bootPending=true;
    requestAnimationFrame(()=>{bootPending=false;boot();});
  }
  function start(){
    boot();
    new MutationObserver(mutations=>{
      for(const m of mutations){
        for(const node of m.addedNodes){
          if(node.nodeType===1 && (node.matches?.(ROOT)||node.querySelector?.(ROOT))){queueBoot();return;}
        }
      }
    }).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  document.addEventListener('shopify:section:load',queueBoot);
})();
